import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import React from 'react'
import { RhfStyleProps } from '../types/RhfStyleProps';
import Label from './Label';

// Omit: 排除 type 指定屬性  & Omit<FormControlLabelProps, "control">

type Props = RhfStyleProps & {
  label: React.ReactNode;

  markProps?: CheckboxProps;
  formControlLabelProps?: FormControlLabelProps
}

/**
 * 等於 MUI.Checkbox + 文字標籤
 */
const CheckBox = ({
  sx, className, style,// RhfStyleProps
  label,

  markProps,
  formControlLabelProps,
  ...restProps
}: Props) => {

  if (sx == null) {
    sx = { marginRight: 3 } // 右側稍微留白
  }

  return (
    <FormControlLabel
      {...formControlLabelProps}
      sx={sx} className={className} style={style}
      label={(typeof (label) === "string" ? <Label text={label} /> : label)}
      control={
        <Checkbox {...markProps} />
      }
    />
  )
}

export default CheckBox